import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDown, ExternalLink } from 'lucide-react';
const products = [{
  id: 'orchestrate',
  name: 'Orchestrate',
  description: 'Intelligent routing and coordination across products',
  endpoints: ['POST /v1/orchestrate/route', 'GET /v1/orchestrate/rules', 'POST /v1/orchestrate/execute']
}, {
  id: 'payments',
  name: 'Payments',
  description: 'Send and receive money globally',
  endpoints: ['POST /v1/payments', 'GET /v1/payments/:id', 'POST /v1/payments/:id/cancel']
}, {
  id: 'wallets',
  name: 'Wallets',
  description: 'Business-grade wallet management',
  endpoints: ['POST /v1/wallets', 'GET /v1/wallets/:id', 'POST /v1/wallets/:id/transfer']
}, {
  id: 'exchange',
  name: 'Exchange',
  description: 'Real-time FX conversion',
  endpoints: ['POST /v1/exchange/quote', 'POST /v1/exchange/convert', 'GET /v1/exchange/rates']
}, {
  id: 'compliance',
  name: 'Compliance',
  description: 'Embedded compliance infrastructure',
  endpoints: ['POST /v1/compliance/verify', 'GET /v1/compliance/checks/:id', 'POST /v1/compliance/screen']
}, {
  id: 'liquidity',
  name: 'Liquidity',
  description: 'Access and route liquidity',
  endpoints: ['GET /v1/liquidity/sources', 'POST /v1/liquidity/request', 'GET /v1/liquidity/positions']
}, {
  id: 'tokenize',
  name: 'Tokenize',
  description: 'Programmable money and settlement',
  endpoints: ['POST /v1/tokenize/mint', 'POST /v1/tokenize/transfer', 'POST /v1/tokenize/burn']
}, {
  id: 'connect',
  name: 'Connect',
  description: 'APIs, SDKs, and webhooks',
  endpoints: ['GET /v1/connect/webhooks', 'POST /v1/connect/webhooks', 'GET /v1/connect/keys']
}];
export function ProductAPIs() {
  const [expandedProduct, setExpandedProduct] = useState<string | null>(null);
  return <section className="py-20 bg-white" data-id="element-335">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-336">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-10 sm:mb-12" data-id="element-337">
          <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-4" data-id="element-338">
            Product APIs
          </h2>
          <p className="text-base sm:text-lg text-slate-600" data-id="element-339">
            Explore endpoints across Obseq's product suite.
          </p>
        </motion.div>

        <div className="max-w-4xl mx-auto space-y-3" data-id="element-340">
          {products.map((product, index) => <motion.div key={product.id} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="bg-white border border-slate-200 rounded-lg overflow-hidden hover:border-slate-300 transition-colors" data-id="element-341">
              <button onClick={() => setExpandedProduct(expandedProduct === product.id ? null : product.id)} className="w-full flex items-center justify-between p-5 text-left" data-id="element-342">
                <div className="flex-1" data-id="element-343">
                  <h3 className="text-lg font-semibold text-slate-900 mb-1" data-id="element-344">
                    {product.name}
                  </h3>
                  <p className="text-sm text-slate-600" data-id="element-345">
                    {product.description}
                  </p>
                </div>
                <ChevronDown className={`w-5 h-5 text-slate-400 transition-transform ${expandedProduct === product.id ? 'rotate-180' : ''}`} data-id="element-346" />
              </button>

              <AnimatePresence data-id="element-347">
                {expandedProduct === product.id && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.2
            }} className="overflow-hidden" data-id="element-348">
                    <div className="px-5 pb-5 border-t border-slate-100 pt-4" data-id="element-349">
                      <div className="space-y-2 mb-4" data-id="element-350">
                        {product.endpoints.map((endpoint, i) => <div key={i} className="flex items-center gap-2" data-id="element-351">
                            <code className="text-xs font-mono bg-slate-100 px-2 py-1 rounded text-slate-700" data-id="element-352">
                              {endpoint}
                            </code>
                          </div>)}
                      </div>
                      <a href="/docs/api-reference" className="inline-flex items-center gap-1 text-sm font-medium text-blue-600 hover:text-blue-700" data-id="element-353">
                        View endpoints
                        <ExternalLink className="w-3 h-3" data-id="element-354" />
                      </a>
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </motion.div>)}
        </div>
      </div>
    </section>;
}